/* eslint-disable no-unused-expressions */
import React from 'react';
import './ManageControlActive.css';
import {Documents} from '../documents';
import {endsControlWithAfterControlNote, getPostControlDocuments} from '../documents/helpers';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as PropertyBucket from '../../Properties/Properties';
import * as ControlFunctions from '.././ManageControlCommons/ManageControlCommons';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import {UploadDocumentsPopup} from '../UploadDocumentsPopup/UploadDocumentsPopup';
import {RemarksPopup} from '../Remarks/RemarksDetail';
import SelectCustom from '../SelectCustom/SelectCustom';
import {getPostControlDocType, getUserRole} from '../../Helpers/utils';
import {hasPermission} from "../ControlStateHelper";
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import * as httpService from "../HttpService/HttpService";
import {downloadXLSXFile} from '../documents/helpers';
import {cloneDeep} from "lodash";
import {EditControlSource} from "../../enums/editControlSource";

class ManageControlActive extends React.Component {

	columnsDefault = [
		{title: 'Numer kontroli', field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
		{title: 'Data rozpoczęcia kontroli', field: 'dateStart', width: 80},//term
		{title: 'Beneficjent', field: 'beneficiary', minWidth: 120, className: 'beneficiary'},
		{title: 'Rodzaj kontroli', field: 'controlKind', width: 110},//kind
		{title: 'Typ kontroli', field: 'controlType', width: 120},//type
		{title: 'Tryb kontroli', field: 'controlMode', width: 90},//mode
		{title: 'Zespół kontrolujący', field: 'controllersDescription', minWidth: 130},
		{title: 'Data otrzymania informacji pokontrolnej przez podmiot kontrolowany', field: 'postControlInfoReceivedDate', width: 90},//postControlInfoIssueDate
		{title: 'Data otrzymania zastrzeżeń', field: 'objectionsReceivedDate', width: 90},//remarksIssueDate
		{title: 'Data wysłania informacji ostatecznej', field: 'finalInfoSentDate', width: 90}//postControlInfoFinalIssueDate
	];
	previousInputFocusId = null;

	constructor(props) {
		super(props);
		this.state = {
			isWaiting: false,
			showPopup: false,
			showInfosListTab: false,
			isUploadDocsWindowVisible: false,
			showRemarksDetail: false,
			showDocumentsControl: null,
			tablePageSize: 10,
			page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
			programSearch: "",
			quickSearch: "",
			filter: [],
			orderBy: "number",
			orderById: "",
			orderDirection: "asc",
			filterChangeOnField: null,
			columns: cloneDeep(this.columnsDefault),
			documentTitle: 'e-Kontrole | Kontrole w trakcie realizacji',
			hadFirstLoad: false
		};
		this.programmsActiveSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Kontrole w trakcie realizacji";

		const newState = cloneDeep(this.state);
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters();
			newState.filter = this.props.controls.tableFilters;
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.programSearch = [store.getState().programs.selected];
		}
		this.setState(newState);
	}

	componentDidUpdate(prevState) {
		if (prevState.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}

		const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);

		if(this.state.hadFirstLoad === false && store.getState().controls.isManageActiveControlsLoading === false) {
			fetchControlData(newState.page, ControlFunctions.getFilterParam(newState.filter), [newState.orderBy, newState.orderDirection], newState.programSearch, newState.quickSearch, newState.tablePageSize, (e) => this.handleRedirect(e));
			this.setState({hadFirstLoad: true});
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.page) {
			this.setState({
				page: 0
			});
			this.props.history.push(`/controls/active`);
			const {fetchControlData} = this.props;
			fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
		}
	}

	getDefaultFilters = () => {
		const columns = cloneDeep(this.columnsDefault);

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue
			}
		});

		return columns;
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	setValues = (values) => {
		this.setState({programSearch: values})
		this.setState({page: parseInt(0) })
		this.props.history.push(`/controls/active`);

		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], values, this.state.quickSearch, this.state.tablePageSize);
	};

	showPopup = (title, notification, type, onClickEvent) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
		})
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	deleteControl = (record) => {
		this.isWaitingOnOff(true);
		let controlId = record.id;
		let url = PropertyBucket.deleteControl(controlId);
		let callPromise = httpService.getService(url, 'DELETE', null);
		let _this = this;

		callPromise.then(
			function (message) {
				_this.props.fetchControlData(0, ControlFunctions.getFilterParam(_this.state.filter), [_this.state.orderBy, _this.state.orderDirection], _this.state.programSearch, _this.state.quickSearch, _this.state.tablePageSize, undefined);
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.deleteControlMessage(), 'notify')
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};


	handleCloseQuest = () => {
		this.setState({showPopup: false});
	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/controls/control_detail/' + row.id);
	};

	onEditButtonClick = (row) => {
		this.props.history.push(`/controls/edit_control/${row.id}/source/${EditControlSource.MANAGE_ACTIVE}`);
	};

	onDeleteButtonClick = (row) => {
		this.showPopup('Komunikat', PropertyBucket.deleteControlConfirmationMessage(row.number), 'confirm', () => {
			this.deleteControl(row)
		})
	};

	onListPreviewButtonClick = (row) => {
		this.props.history.push('/controls/control_list_detail/' + row.id);
	};

	onPostControlInfoRedirect = (row) => {
		this.props.history.push('/controls/post_control_info_detail/' + row.postControlDocuments[0].postControlInfo.infoId);
	};

	onPostControlNoteRedirect = (row) => {
		this.props.history.push('/controls/post_control_note_detail/' + row.postControlDocuments[0].postControlNote.noteId);
	};

	onPostInfoPreviewButtonClick = async(row) => {
		if (row.postControlDocuments) {
			let documents = await getPostControlDocuments(row.id)
			const { setFiltersData } = this.props;
			setFiltersData({ filter: this.state.filter, tableName: this.state.documentTitle });
			const { setQuickSearchData } = this.props;
			setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
			this.showPopup('Dokumenty pokontrolne', ControlFunctions.displayInfosListTab(documents, row.number, row.id,'controls', () => {
				this.setState({
					record: row,
					documents: documents,
					isUploadDocsWindowVisible: true,
					showPopup: false,
					docType: getPostControlDocType(documents)
				});
			}), 'notify')
		} else {
			this.showPopup('Komunikat', 'Kontrola nie ma jeszcze dokumentu pokontrolnego.', 'notify')
		}
	};

	prepareData = (data) => {
		return data.map(ControlFunctions.setupControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.filter.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}
			
			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	isDisableEdit = (data) => {
		return !hasPermission(data, "control.manage.edit");
	};

	isDisableDelete = (data) => {
		return !hasPermission(data, "control.manage.delete");
	};

	onRemarksButtonClick = async (row) => {
		if (row.postControlInfoReceivedDate) {
			let documents = await getPostControlDocuments(row.id)
			this.setState({
				showRemarksDetail: true,
				record: row,
				documents: documents,
				showPopup: false
			});
		}
		else {
			this.showPopup('Komunikat', PropertyBucket.getNoPostControlRemarksMessage(), 'notify')
		}
	};

	handlePageChange(page, size) {
		this.setState({page: parseInt(page) })
		const {fetchControlData} = this.props;
		fetchControlData(page, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, size);
	}

	handleFilterChange(filter) {
		this.state.filter.forEach((filterField, id) => {
			if (filterField.filterValue !== filter[id].filterValue) {
				this.setState({ filterChangeOnField: filter[id] });
			}
		});

		this.setState({page: parseInt(0) })
		this.setState({filter: filter })
		this.props.history.push(`/controls/active`);
		const {fetchControlData, setFiltersData} = this.props;
		setFiltersData({ filter, tableName:  this.state.documentTitle });
		fetchControlData(0, ControlFunctions.getFilterParam(filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize, () => this.focusOnFilterElement(this));
	}

	handleQuickSearchChange(search) {
		this.setState({quickSearch: search, page: 0});
		this.props.history.push(`/controls/active`);
		const {fetchControlData, setQuickSearchData} = this.props;
		const focusOnQuickSearchInput = () => {
			const element = document.querySelector('[placeholder="Szukaj"]');
			element.focus();
		};
		setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, search, this.state.tablePageSize, focusOnQuickSearchInput);
	}


	handleOrderChange(column, order) {
		this.setState({page: parseInt(0) })
		const orderColumn = (this.state.columns[column] ? this.state.columns[column].field :'')
		this.setState({orderById: column})
		this.setState({orderBy: orderColumn})
		this.setState({orderDirection: order})
		this.props.history.push(`/controls/active`);
		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [orderColumn, order], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
	}

	handleListDownload() {
		const date = new Date(Date.now()).toLocaleString().split(',')[0];
		const fileName = `Zarządzaj_kontrolami_W_trakcie_realizacji_${date}.xlsx`;
		downloadXLSXFile(fileName, 'W_trakcie_realizacji', this.state.orderBy, this.state.orderDirection);
	}

	render() {
		let userRole = getUserRole(this.props.userData);
		let loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.manageActiveControls;
		let loadedProgsData = userRole === 'SA' ? store.getState().programs.programs : null;
		let table;
		let dropdown;
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
							title={this.state.popUp.title}
							notification={this.state.popUp.notification}
							link={this.state.popUp.link}
							onClickEvent={this.state.popUp.onClickEvent}
							closePopUp={this.handleClosePopUp}
			/>) : null;

		if (this.props.controls && this.props.controls.isManageActiveControlsLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}
				this.prepareData(loadedControlsData);

				table = <TableCustomLazyLoading
					isActionsMultilines
					columns={this.state.columns}
					data={loadedControlsData}
					orderBy={this.state.orderById}
					orderDirection={this.state.orderDirection}
					count={totalElements}
					page={this.state.page}
					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1', margin: 0, padding: 0 } },
							tooltip: <span>Szczegóły kontroli<span className='sr-only'> {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'editButton',
							iconProps: {
								style: {
									fontSize: '24px',
									color: this.isDisableEdit(rowData) ? '#ccc' : '#0d47a1'
								}
							},
							tooltip: <span>Edytuj<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onEditButtonClick(rowData);
							},
							disabled: this.isDisableEdit(rowData),
						}),
						rowData => ({
							icon: 'delete',
							iconProps: {
								style: {
									fontSize: '24px',
									color: this.isDisableDelete(rowData) ? '#ccc' : '#0d47a1'
								}
							},
							tooltip: <span>Usuń <span
								className='sr-only'> kontrolę: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDeleteButtonClick(rowData);
							},
							disabled: this.isDisableDelete(rowData)
						}),
						rowData => ({
							icon: 'find_in_page',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Podgląd listy<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onListPreviewButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'description',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Dokumenty pokontrolne<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onPostInfoPreviewButtonClick(rowData);
							},
						}),
						rowData => ({
							icon: 'message',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Zastrzeżenia<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onRemarksButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'folder',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							tooltip: <span>Pliki<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: async (event, rowData) => {
								let documents = await getPostControlDocuments(rowData.id)
								this.setState({endsControlWithAfterControlNote : endsControlWithAfterControlNote(documents)})
								this.setState({showDocumentsControl: rowData});
							},
						}),
					]}
					initialPage={this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}
					onQuickSearchChange={(value) => {
						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.quickSearch}
					pageSize={this.state.tablePageSize}
					onChangePage={
						(page, size) => {
							this.props.history.push(`/controls/active/${parseInt(page) + 1}`)
							this.setState({page: parseInt(page)})
							this.setState({tablePageSize: parseInt(size)})
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsActiveSelectId'
					dropdownId='programmsActiveDropdownId'
					label='Programy'
					parentRef={this.programmsActiveSelectRef}
				/>
			</div>
		}

		const { showDocumentsControl: control } = this.state;
		return (
			<div id='control_search' className='active_controls'>
				<div id='add_control'>
					<h2 className='mb-4 float-left'>Kontrole - W trakcie realizacji</h2>
					<Link to='/create_control' className='btn save-btn' id='plus_img_container'><i data-v-db6946bc=''
					                                                                               aria-hidden='true'
					                                                                               className='v-icon material-icons theme--light v-list-text'>add</i><span>UTWÓRZ KONTROLĘ</span></Link>
					<div className='clearfix'/>
				</div>
				<div>
					{userRole === 'SA' ? dropdown : null}
					<div id='controls_table'>
						<div style={{display: 'flex', flexDirection: 'column'}}>
							<button type='button' onClick={() => this.handleListDownload()} className='btn save-btn download-xlsx-btn'>
								<i data-v-db6946bc='' aria-hidden='true' className='v-icon material-icons theme--light v-list-text'>download</i><span>POBIERZ</span>
							</button>
							{table}
						</div>
					</div>
				</div>
				{this.state.showRemarksDetail &&<RemarksPopup
													data= {this.state.record}
													documents={this.state.documents}
													closeWindow = {() => this.setState({
														showRemarksDetail: false,
													 })}
													onlyPreview = {true}
												/>}
				{this.state.isUploadDocsWindowVisible && <UploadDocumentsPopup
																isPossibleSendData={false}
																isPossibleChangeDate={this.state.docType === 'INF' ? true : false}
																control={this.state.record}
																showPopup={this.showPopup}
																handleLoading={this.isWaitingOnOff}
																handleClose={() => this.setState({
																	isUploadDocsWindowVisible: false,
																})}
																/>}
				{popUp}
				{control !== null &&
					<Documents
						controlUuid={control.uuid}
						endsWithAfterControlNote={ this.state.endsControlWithAfterControlNote }
						hiddenButtons
						inPopup
						removingOnListForbidden
						withDocumentsList
						onCancel={() => this.setState({showDocumentsControl: null})}
					/>
				}
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isManageActiveControlsLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch, ownParams) => {
	let url = PropertyBucket.getControlsActive();
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}
	return {
		fetchControlData: (pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, undefined, successCallback, 'manageActive')),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
	}
};
export const ManageControlActiveProvider = connect(mapStateToProps, mapDispatchToProps)(ManageControlActive);
